import { cn } from "@/lib/chillnn/cn";

type Props = {
	label: string;
	title: string;
	isSelected?: boolean;

	iconChildren: React.ReactNode;
};

export const Item = ({ label, title, isSelected, iconChildren }: Props) => {
	return (
		<div className="border-b last:border-b-0">
			<div className="flex items-center justify-between border-b-[#DDDDDD] py-2">
				<div className="flex items-center">
					<div className="flex w-10 justify-center">{iconChildren}</div>

					<div>
						<p className="text-xs text-[#868686]">{label}</p>

						<p className={cn("font-base text-sm ", isSelected ? "text-black" : "text-[#9e9e9e]")}>
							{title}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
